import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

declare var $: any;

@Directive({
    selector: '[appTooltipInfo]',
    standalone: false
})
export class TooltipInfoDirective implements AfterViewInit {
  tooltipData = '';

  @Input() set tooltipDataValue(value: string) {
    this.tooltipData = value;

    $(this.element.nativeElement).tooltip('dispose');
    this.showTooltip();
  }
  @Input() placement: string;
  @Input() trigger = 'hover';
  @Input() html = true;
  @Input() appUITooltipWithColor = true;

  constructor(private readonly element: ElementRef) {}

  ngAfterViewInit() {
    this.showTooltip();
  }

  private tooltipTemplate() {
    return `<div class="tooltip" role="tooltip">
      <div class="arrow tooltip-arrow-override"></div>
      <div class="tooltip-inner tooltip-override"></div>
    </div>`;
  }

  private showTooltip() {
    if (!this.appUITooltipWithColor) {
      return;
    }

    $(this.element.nativeElement).tooltip({
      title: this.tooltipData,
      placement: this.placement,
      trigger: this.trigger,
      template: this.tooltipTemplate(),
      html: this.html
    });
  }
}
